import React from 'react';
import { Box } from '@mui/material';
import { IconGraphy, Typography, Button } from '@leapeasy/ui-kit';
import { getRoleLabel } from 'constants/userRoles';
import { fitContentTextColumnOptions } from 'utils/fitContentTextColumnOptions';

const TABLE_TEXT_COLOR = '#3C393D';

const textCell = (value) => (
  <Typography variant="body2" style={{ color: TABLE_TEXT_COLOR }}>
    {value ?? '-'}
  </Typography>
);

const requestButtonCell = (onRequest) => (
  <Button
    variant="primary"
    onClick={onRequest}
    style={{
      height: 32,
      minWidth: 96,
      borderRadius: 8,
      fontSize: 13,
      padding: '0 12px',
    }}
  >
    Request
  </Button>
);

export const getRequestLandlordColumns = ({ onRequest, onRowDetail }) => [
  {
    name: 'Name',
    key: 'name',
    options: {
      ...fitContentTextColumnOptions(),
      sort: true,
      customBodyRenderer: (value) => textCell(value),
    },
  },
  {
    name: 'Phone',
    key: 'phone',
    options: {
      sort: true,
      customBodyRenderer: (value) => textCell(value),
    },
  },
  {
    name: 'Primary Contact',
    key: 'primary_contact',
    options: {
      sort: true,
      customBodyRenderer: (value) => textCell(value),
    },
  },
  {
    name: 'Address',
    key: 'address',
    options: {
      sort: true,
      flex: '160px 1 1',
      customBodyRenderer: (value) => textCell(value),
    },
  },
  {
    name: 'Email',
    key: 'email_address',
    options: {
      sort: true,
      flex: '160px 1 1',
      customBodyRenderer: (value) => textCell(value),
    },
  },
  {
    name: 'Residential Properties',
    key: 'number_of_residential_buildings',
    options: {
      sort: true,
      customBodyRenderer: (value) => textCell(value),
    },
  },
  {
    name: 'Units',
    key: 'number_of_units',
    options: {
      sort: true,
      customBodyRenderer: (value) => textCell(value),
    },
  },
  {
    name: 'Created',
    key: 'sf_createdDate',
    options: {
      sort: true,
      customBodyRenderer: (value) => textCell(value),
    },
  },
  {
    name: 'Request',
    key: 'request',
    options: {
      customBodyRenderer: (_, row) => requestButtonCell(() => onRequest(row[0])),
    },
  },
  {
    name: 'Detail',
    key: 'detail',
    options: {
      customBodyRenderer: (_, row) => (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <IconGraphy
            icon="FileFolder.StickyNote2"
            style={{ color: '#702572', cursor: 'pointer' }}
            onClick={() => onRowDetail?.(row[0])}
          />
        </Box>
      ),
    },
  },
];

export const getRequestVPColumns = ({ onRequest, onRowDetail }) => [
  {
    name: 'Name',
    key: 'username',
    options: {
      ...fitContentTextColumnOptions(),
      sort: true,
      customBodyRenderer: (value) => textCell(value),
    },
  },
  {
    name: 'Phone',
    key: 'phone',
    options: {
      sort: true,
      customBodyRenderer: (value) => textCell(value),
    },
  },
  {
    name: 'Job Title',
    key: 'job_title',
    options: {
      sort: true,
      customBodyRenderer: (value) => textCell(value),
    },
  },
  {
    name: 'Email',
    key: 'accepter_email',
    options: {
      sort: true,
      flex: '160px 1 1',
      customBodyRenderer: (value) => textCell(value),
    },
  },
  {
    name: 'Properties',
    key: 'property_count',
    options: {
      sort: true,
      customBodyRenderer: (value) => textCell(value),
    },
  },
  {
    name: 'Role',
    key: 'accepter_role',
    options: {
      sort: true,
      customBodyRenderer: (value) => textCell(getRoleLabel(value)),
    },
  },
  {
    name: 'Created',
    key: 'createdAt',
    options: {
      sort: true,
      customBodyRenderer: (value) => textCell(value),
    },
  },
  {
    name: 'Request',
    key: 'request',
    options: {
      customBodyRenderer: (_, row) => requestButtonCell(() => onRequest(row[0])),
    },
  },
  {
    name: 'Detail',
    key: 'detail',
    options: {
      customBodyRenderer: (_, row) => (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <IconGraphy
            icon="FileFolder.StickyNote2"
            style={{ color: '#702572', cursor: 'pointer' }}
            onClick={() => onRowDetail?.(row[0])}
          />
        </Box>
      ),
    },
  },
];

export function formatLandlordAddress(landlord) {
  return [
    landlord?.billingStreet,
    landlord?.billingCity,
    landlord?.billingState,
    landlord?.billingPostalCode,
  ]
    .filter(Boolean)
    .join(' ');
}

export function formatLandlordCreatedDate(landlord) {
  if (!landlord?.sf_createdDate) return '-';
  try {
    return new Date(landlord.sf_createdDate).toISOString().slice(0, 10);
  } catch {
    return '-';
  }
}
